import { UserActionPayloadType, UserData, UserFilterType } from './types';
import baseApiBackoffice from '../baseApiBackoffice';
import { injectEndpoints, PaginatedResponse, PaginationType } from '../util';
import { fixSearchParams } from '@zignaly-open/ui';

export const api = injectEndpoints(baseApiBackoffice, (builder) => ({
  users: builder.query<
    PaginatedResponse<UserData>,
    UserFilterType & PaginationType
  >({
    query: (params) => ({
      url: 'users',
      method: 'GET',
      params: fixSearchParams(params),
    }),
  }),
  usersCsv: builder.query<string, UserFilterType>({
    query: (params) => ({
      url: 'users',
      method: 'GET',
      params: {
        ...fixSearchParams(params),
        format: 'csv',
        limit: 'all',
        offset: '0',
      },
      responseHandler: (response) => response.text(),
    }),
  }),
  disable2FA: builder.mutation<void, UserActionPayloadType>({
    query: ({ userId }) => ({
      url: `disable-2fa/${userId}`,
      method: 'POST',
    }),
  }),
  ban: builder.mutation<void, UserActionPayloadType>({
    query: ({ userId }) => ({
      url: `ban-user/${userId}`,
      method: 'POST',
    }),
  }),
  unban: builder.mutation<void, UserActionPayloadType>({
    query: ({ userId }) => ({
      url: `unban-user/${userId}`,
      method: 'POST',
    }),
  }),
  disableWithdrawals: builder.mutation<void, UserActionPayloadType>({
    query: ({ userId }) => ({
      url: `disable-withdrawals/${userId}/1`,
      method: 'POST',
    }),
  }),
  enableWithdrawals: builder.mutation<void, UserActionPayloadType>({
    query: ({ userId }) => ({
      url: `disable-withdrawals/${userId}/0`,
      method: 'POST',
    }),
  }),
  changeEmail: builder.mutation<
    { data?: { error: { code: number; msg: string } } },
    UserActionPayloadType & { email: string }
  >({
    query: ({ userId, email }) => ({
      url: `change-email/${userId}`,
      method: 'POST',
      body: {
        email,
      },
    }),
  }),
}));

export const {
  useLazyUsersQuery,
  useDisable2FAMutation,
  useBanMutation,
  useUnbanMutation,
  useDisableWithdrawalsMutation,
  useEnableWithdrawalsMutation,
  useUsersQuery,
  useChangeEmailMutation,
  useLazyUsersCsvQuery,
} = api;
